import { create } from 'zustand';

// ============================================================================
// lib/worktableContext.ts — КОНТЕКСТ РАБОЧЕГО СТОЛА (master→slave фильтрация).
// Параметры контекста — переменные уровня рабочего стола/страницы. Виджеты
// ссылаются на них в отборах как @context.<имя> (например @context.Контрагент).
// Когда значение меняется (выбор в списке-мастере, ввод в виджете контекста),
// ВСЕ виджеты с таким отбором обновляются автоматически. Параметры виджета
// (@param.<имя>) — локальны для одного виджета. Стор сбрасывается при
// входе на рабочий стол (WorktablePage). SSoT данных — сервер, контекст —
// только сессия клиента (не хранится).
// ============================================================================

interface WorktableContextState {
  /** Текущие значения параметров контекста (имя → значение) */
  params: Record<string, string>;
  setParam: (name: string, value: string) => void;
  clearParam: (name: string) => void;
  reset: () => void;
}

export const useWorktableContext = create<WorktableContextState>((set) => ({
  params: {},
  setParam: (name, value) =>
    set((s) => ({ params: { ...s.params, [name]: value } })),
  clearParam: (name) =>
    set((s) => {
      const next = { ...s.params };
      delete next[name];
      return { params: next };
    }),
  reset: () => set({ params: {} }),
}));
